import React from "react";
import {
  FaClock,
  FaPizzaSlice,
  FaChair,
  FaFootballBall,
  FaGlassCheers,
} from "react-icons/fa";

const WhyUs = () => {
  const highlights = [
    {
      icon: <FaClock className="text-3xl sm:text-4xl" />,
      line1: "90 Minutes of",
      line2: "Sports",
    },
    {
      icon: <FaGlassCheers className="text-3xl sm:text-4xl" />,
      line1: "Dedicated Party /",
      line2: "Social Area",
    },
    {
      icon: <FaFootballBall className="text-3xl sm:text-4xl" />,
      line1: "Multiple Sports to",
      line2: "Choose From",
    },
    {
      icon: <FaChair className="text-3xl sm:text-4xl" />,
      line1: "Tables, Chairs, Setup",
      line2: "& Cleanup Included",
    },
    {
      icon: <FaPizzaSlice className="text-3xl sm:text-4xl" />,
      line1: "Custom Food &",
      line2: "Beverage Options",
    },
  ];

  return (
    <div className="w-full py-16 sm:py-20 bg-white px-3 sm:px-6 md:px-8 lg:px-12 border-t border-gray-100">
      <div className="max-w-7xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-black text-primaryBtnColor mb-12 sm:mb-16 uppercase tracking-tight">
          Why Strikes &amp; Shots?
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6 lg:gap-8 items-start justify-items-center">
          {highlights.map((item, index) => (
            <div
              key={index}
              className={`flex flex-col items-center text-center group w-full ${
                index === 4 ? "col-span-2 sm:col-span-1" : "col-span-1"
              }`}
            >
              {/* Circular Icon with shadow & hover transition */}
              <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-100 flex items-center justify-center text-primaryBtnHoverColor mb-4 sm:mb-5 group-hover:bg-primaryBtnHoverColor group-hover:text-white transition-all duration-300 shadow-md group-hover:scale-105">
                {item.icon}
              </div>

              {/* Title with strictly two lines */}
              <h3 className="text-xs sm:text-sm md:text-base font-poppins font-semibold text-gray-800 leading-snug">
                <span className="block whitespace-nowrap">{item.line1}</span>
                <span className="block whitespace-nowrap text-gray-700">{item.line2}</span>
              </h3>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
